import listReducer from '../common/list-reducer';

import {getDiscountsAction} from "./actions";

const discountsReducer = listReducer.bind(getDiscountsAction.getListReduceThisObj());

export default ({
    discounts: discountsReducer
});